function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  id: "member_inline_svg__Page-13",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "member_inline_svg__01-\\u9996\\u9801---country---s0-v1",
  transform: "translate(-1196 -28)",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "member_inline_svg__Atoms-/-Icon-/-user-/-solid",
  transform: "translate(1196 28)"
}, React.createElement("g", {
  id: "member_inline_svg__circle-user-duotone",
  transform: "translate(4 4)"
}, React.createElement("path", {
  d: "M7.947 8.968c1.465 0 2.653-1.12 2.653-2.5s-1.187-2.5-2.653-2.5c-1.467 0-2.653 1.118-2.653 2.5s1.186 2.5 2.653 2.5zM8.891 8.968H6.533c-1.752 0-3.226 1.4-3.821 3.361 1.282 1.631 3.05 2.639 5 2.639 1.95 0 3.718-1.01 5-2.639-.597-1.96-2.07-3.361-3.82-3.361z",
  id: "member_inline_svg__Path",
  fill: "#FFF"
}), React.createElement("path", {
  d: "M8 0a8 8 0 00-8 8 8 8 0 008 8 8 8 0 008-8 8 8 0 00-8-8zm0 4a2.25 2.25 0 110 4.5A2.25 2.25 0 018 4zm0 10a5.984 5.984 0 01-4.24-1.76C4.265 10.935 5.515 10 7 10h2c1.486 0 2.736.934 3.24 2.24A5.982 5.982 0 018 14z",
  id: "member_inline_svg__Shape",
  fill: "#0558E6"
})))));

function SvgMemberinline(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default SvgMemberinline;